import { gql } from '@common/hooks';
import { ApprovalChainContentFragments } from '@approvals/graphql/fragments';
import { HistoryInfoFragment } from '@common/graphql';
import { BillingCardFragment } from '@institutions/graphql';

export const EXTENSION_OFFER_HEADER_FRAGMENT = gql`
  fragment ExtensionOfferHeaderFragment on ExtensionOffer {
    id
    state
    stateChangedAt
    rejectionReason
    rejectionDetails
    rejectionNotes
    billingCard {
      ...BillingCardFragment
    }
  }
  ${BillingCardFragment}
`;

export const EXTENSION_OFFER_DETAILS_FRAGMENT = gql`
  fragment ExtensionOfferDetailsFragment on ExtensionOffer {
    id
    startDate
    endDate
    timeoffDescription
    shiftType
    originalShiftType
    billingRegularRate
    originalBillingRegularRate
    originalHoursPerShift
    originalShiftsPerWeek
    originalEndDate
    hoursPerShift
    shiftsPerWeek
    extensionReason
    overtimeThreshold
    notVoidedSourceAssignmentTerms {
      id
      startDate
      endDate
      billingRegularRate
      timeoffDescription
      shiftsPerWeek
      shiftType
    }
    offerChangeRequests {
      id
      note
      offerChangeResponse {
        id
        note

        detail {
          ... on OfferAcceptanceResponseDetail {
            id
            oldEndDate
            oldShiftType
            oldShiftsPerWeek
            oldHoursPerShift
            oldTimeoffDescription
          }
          ... on ExtensionOfferAcceptanceResponseDetail {
            id
            oldEndDate
            oldShiftType
            oldShiftsPerWeek
            oldHoursPerShift
            oldTimeoffDescription
          }
        }

        updatedAt
        worksMembership {
          id
          name
        }
      }
      createdAt
      updatedAt
      worksMembership {
        id
        name
      }
    }
  }
`;

export const EXTENSION_OFFER_FRAGMENT = gql`
  fragment ExtensionOfferFragment on ExtensionOffer {
    id
    state
    startDate
    endDate
    extensionReason
    sourceStartDate
    sourceEffectiveAt
    sourcePercentageComplete
    sourceEndDate
    sourceEstimatedBudget
    createdAt
    lengthInWeeks
    history {
      ...HistoryInfoFragment
    }

    lastTermCreatedTillExtensionOfferCreation {
      id
      organizationUnit {
        id
        department {
          id
          name
          organizationBusiness {
            id
            name
            city
            stateCode
          }
        }
      }
    }

    notVoidedSourceAssignmentTerms {
      id
      currentlyActive
      upcoming
      past
      estimatedBudget
      effectiveAt
      startDate
      endDate
      lengthInWeeks
      billingRegularRate
      shiftsPerWeek
      hoursPerShift
      shiftType
      timeoffDescription
      createdByName
      updatedFields
      irrelevant
      updatedAt
      createdAt
      employmentType
      organizationUnit {
        id
        name
        costCenter
      }
      staffingRequestAssignment {
        id
        organization {
          id
          billingEnabled
        }
        worksBillingConfig {
          id
        }
      }
      hiringLeader {
        id
        name
      }
      canVoid {
        value
      }
      canUpdate {
        value
      }
    }
    offerChangeRequests {
      id
      note
      updatedAt
      createdAt
      worksMembership {
        id
        name
      }
      canCreateResponse {
        value
      }
      offerChangeResponse {
        id
        note
        updatedAt
        worksMembership {
          id
          name
        }
      }
    }

    createdBy {
      id
      name
    }
    canRetract {
      value
    }
    canReject {
      value
    }
    canAccept {
      value
    }
    canApprove {
      value
    }
    ...ExtensionOfferApprovalChainsFragment
    ...ExtensionOfferHeaderFragment
    ...ExtensionOfferDetailsFragment
  }
  ${EXTENSION_OFFER_HEADER_FRAGMENT}
  ${EXTENSION_OFFER_DETAILS_FRAGMENT}
  ${ApprovalChainContentFragments.extensionOffer}
  ${HistoryInfoFragment}
`;
